import type { PropsWithChildren, ReactNode } from 'react'

import Error404Image from '@ps/ds/assets/illustrations/il-error-404.svg'
import { Empty, EmptyProps } from '@ps/ds/components/blocks/Empty/Empty'
import { Separator } from '@ps/ds/components/primitives/Separator/Separator'

export type NotFoundPageProps = PropsWithChildren<
  Pick<EmptyProps, 'primaryAction' | 'secondaryAction' | 'linkAction'>
> & {
  title?: string
  description?: string
  image?: ReactNode
}

export const NotFoundPage = ({
  title = 'Page not found',
  description = 'The page you are looking for doesn’t exist or has been moved.',
  image = <img src={Error404Image} alt="" aria-hidden="true" />,
  primaryAction,
  secondaryAction,
  linkAction,
  children,
}: NotFoundPageProps) => {
  const emptyProps: EmptyProps = {
    title,
    description,
    image,
    primaryAction,
    secondaryAction,
    linkAction,
  }

  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-6">
      <div className="flex flex-col gap-16">
        <div className="hidden md:block">
          <Empty {...emptyProps} size="large" />
        </div>

        <div className="block md:hidden">
          <Empty {...emptyProps} size="default" />
        </div>

        {children && <Separator />}
      </div>

      {children}
    </div>
  )
}
